// frontend/controllers/scroll_to_top_controller.js
import { Controller } from "@hotwired/stimulus"

// Shows the button once the page has been scrolled further than one viewport
// height and scrolls back to the top on click.
export default class extends Controller {
  static classes = ["visible", "hidden"]

  connect() {
    this.ticking = false
    this.onScroll = () => {
      if (this.ticking) return
      this.ticking = true
      requestAnimationFrame(() => {
        this.update()
        this.ticking = false
      })
    }
    window.addEventListener("scroll", this.onScroll, { passive: true })
    window.addEventListener("resize", this.onScroll, { passive: true })
    this.update()
  }

  disconnect() {
    window.removeEventListener("scroll", this.onScroll)
    window.removeEventListener("resize", this.onScroll)
  }

  scroll() {
    const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches
    window.scrollTo({ top: 0, behavior: reduceMotion ? "auto" : "smooth" })
  }

  update() {
    const visible = window.scrollY > window.innerHeight
    this.element.classList.remove(...(visible ? this.hiddenClasses : this.visibleClasses))
    this.element.classList.add(...(visible ? this.visibleClasses : this.hiddenClasses))
  }
}
